import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";

import { Grid } from '@material-ui/core';

import { GET_LAYOUT_TYPE } from "../../../queries/layout_type";
import DeleteLayoutType from "./delete";

// components
import DrawerPlacements from '../../../components/DrawerPlacements';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddLayoutTypes from '../../../pages/layoutTypes/actions/create';
import UpdateLayoutTypes from '../../../pages/layoutTypes/actions/edit';

const layoutType = ({ data: { layoutType, loading, error }}) => {

  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <DeleteLayoutType selectedRows = {selectedRows} layoutTypes={layoutType}/>
    )
  };

  const ActionsRow = (tableMeta) => {
    var id = tableMeta.rowData[1];
    var name = tableMeta.rowData[2];
    var description = tableMeta.rowData[3];
    return (
      <>
      <DrawerPlacements title="Edit Layout Type" iconButtonAction={false} labeButtonAction={name}>
        <UpdateLayoutTypes id = {id} name = {name} description = {description}></UpdateLayoutTypes>
      </DrawerPlacements>
      </>
    );
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Layout Types"/>
        </Grid>
        <Grid item xs={2}>
          <DrawerPlacements title="Layout Types" labeButtonAction="Add">
            <AddLayoutTypes></AddLayoutTypes>
          </DrawerPlacements>

        </Grid>
      </Grid>
      
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={layoutType}
                columns={[
                  {
                    name    : 'name',
                    options : {
                      customBodyRender: (value, tableMeta, updateValue) => { 
                        return (ActionsRow(tableMeta))
                      },
                      empty  : true,
                      filter : true,
                      sort   : true,                     
                    }
                  },{
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },{
                    name    : 'name',
                    options : {
                      display : false
                    }
                  },
                  'description'
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const LayoutTypes = graphql(GET_LAYOUT_TYPE)((layoutType));